module.exports = __webpack_public_path__ + "static/media/utility.df17c2b5.svg";